import { useQuery } from '@tanstack/react-query';
import { SourcingService } from 'api-clients/monolith';
import { useEffect, useMemo } from 'react';

import { useOpeningContext } from '@/contexts/opening-context';
import { useOpeningSlug } from '@/hooks/use-opening-slug';

import { AggregateView } from './aggregate-view';

export function SourcingOpenings() {
  const openingSlug = useOpeningSlug();
  const { showAggregateData, setShowCheckbox, currentHiringGoalId } =
    useOpeningContext();

  const { data, isFetching, isError } = useQuery({
    queryKey: [
      'sourcingFunnels',
      openingSlug,
      currentHiringGoalId,
      showAggregateData,
    ],
    queryFn: () =>
      SourcingService.getInternalApiSourcingOpeningsSourcingFunnels(
        openingSlug,
        currentHiringGoalId,
        showAggregateData,
      ),
  });

  if (isError) throw new Error('Failed to fetch sourcing funnels');

  const sourcingOpenings = useMemo(() => data?.sourcing_funnels ?? [], [data]);
  const aggregateData = useMemo(
    () => (data && data.aggregate ? [data.aggregate] : []),
    [data],
  );

  useEffect(() => {
    if (sourcingOpenings.length > 0) {
      setShowCheckbox(true);
    }
  }, [setShowCheckbox, sourcingOpenings]);

  if (!isFetching && aggregateData.length === 0) return null;

  return (
    <>
      <div className="w-full">
        <div className="overflow-x-auto">
          <div className="min-w-max">
            <div className="space-y-4 pb-2">
              <AggregateView
                aggregateData={aggregateData}
                sourcingOpenings={sourcingOpenings}
                isFetching={isFetching}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
